var map = {
	"./end-darkgrey.png": "5b40",
	"./end-green.png": "7364",
	"./end-lightgrey.png": "b81a",
	"./end-orange.png": "0503",
	"./end-red.png": "feb4",
	"./end-yellow.png": "5592",
	"./energifera-logo.png": "5bb2",
	"./genera-logo.png": "b5b2",
	"./middle-darkgrey.png": "102d",
	"./middle-green.png": "ae32",
	"./middle-lightgrey.png": "4045",
	"./middle-orange.png": "a6fe",
	"./middle-red.png": "9975",
	"./middle-yellow.png": "2a0f",
	"./start-darkgrey.png": "7d90",
	"./start-green.png": "ddbf",
	"./start-lightgrey.png": "dafd",
	"./start-orange.png": "9c28",
	"./start-red.png": "05a8",
	"./start-yellow.png": "49d6",
	"./syndesia-logo-white.svg": "10f1",
	"./syndesia-logo.svg": "53e6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";